var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUpload = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, "//\n  ", _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-solid/arrow-up-tray"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 626655"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1029 14.7029C31.0402 13.7657 32.5598 13.7657 33.4971 14.7029L47.8971 29.1029C48.8343 30.0402 48.8343 31.5598 47.8971 32.4971C46.9598 33.4343 45.4402 33.4343 44.5029 32.4971L34.2 22.1941L34.2 59.6C34.2 60.9255 33.1255 62 31.8 62C30.4745 62 29.4 60.9255 29.4 59.6L29.4 22.1941L19.0971 32.4971C18.1598 33.4343 16.6402 33.4343 15.7029 32.4971C14.7657 31.5598 14.7657 30.0402 15.7029 29.1029L30.1029 14.7029Z",
    fill: "#2EC4B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.4C3 3.07452 4.07452 2 5.4 2H58.2C59.5255 2 60.6 3.07452 60.6 4.4C60.6 5.72548 59.5255 6.8 58.2 6.8H5.4C4.07452 6.8 3 5.72548 3 4.4Z",
    fill: "#2EC4B2"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUpload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/upload.a5c45259.svg";
export { ForwardRef as ReactComponent };